import { render, staticRenderFns } from "./elseAddAccount.vue?vue&type=template&id=80c58276&scoped=true&"
import script from "./elseAddAccount.vue?vue&type=script&lang=js&"
export * from "./elseAddAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c58276",
  null
  
)

export default component.exports